<template>

  <div class="card card-with-search border-0 card-with-shadow card-with-shadow-parent ">
    <div class="text-justify">
      <div class="row">
        <!-- <dynamic-form-preview v-bind:Id="id"></dynamic-form-preview> -->
        <div class="col-sm-12">
            <div id="pdf-section" class="container-wrapper" ref="pdfSection" >
              <div class="stacked-divs" id="print">
                <!-- Header -->
                <div class="position-relative form-header p-3" ref="pdfSectionHeader">
                  <table class="my-3 align-items-center container_btn" v-if="companyInfo != null" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td class="" style="width: 60%;">
                        <table class="user-header-media" style="width: 100%;  font-size: 0.8rem;">
                          <tr>
                            <td style="width: 30%; padding-right: 1rem;">
                              <img v-if="companyInfoCheck.checked_logo == true" :src="companyInfo.logo" alt="LOGO" style="width: 100%; height: auto;" />
                            </td>
                            <td>
                              <h6 class="mb-0">{{ companyInfoCheck.checked_company_name == true ? companyInfo.company_name : ''}} <span v-if="companyInfoCheck.checked_category_name == true">{{ ' (' + companyInfo.category_name + ')' }}</span></h6>
                              <p class="mt-2" v-if="companyInfoCheck.checked_company_number == true">Reg No. {{ companyInfo.comapny_number }}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td style="width: 40%; ">
                        <table style="width: 100%;  font-size: 0.8rem;">
                          <tr v-if="companyInfoCheck.checked_company_phone == true">
                            <td style="padding-right: 1rem;">
                              <app-icon :name="'phone'" class="icon-size"/>
                            </td>
                            <td>
                              <p class="mb-1">{{ companyInfo.company_phone }}</p>
                            </td>
                          </tr>
                          <tr v-if="companyInfoCheck.checked_company_email == true">
                            <td style="padding-right: 1rem;">
                              <app-icon :name="'mail'" class="icon-size"/>
                            </td>
                            <td>
                              <p class="mb-1">{{ companyInfo.company_email }}</p>
                            </td>
                          </tr>
                          <tr v-if="companyInfoCheck.checked_address == true">
                            <td style="padding-right: 1rem;">
                              <app-icon :name="'map-pin'" class="icon-size"/>
                            </td>
                            <td>
                              <p class="mb-1">{{ companyInfo.address }}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div class="col-12 text-center">
                    <p class="mb-2" v-if="companyInfoCheck.checked_description == true">
                      {{ companyInfo.description }}
                    </p>
                  </div>
                </div>
                <!-- Header Ends-->

                <div class="main__wrapper header-color-style formStyle form-inner-container p-3">


                <el-container>
                  <el-main :style="cssProps" >
                    <el-form class="formElements">
                      <template v-for="(eachFormObj, eachFormIndex) in forms">
<!--                        <div v-if="eachFormIndex > 0" class="html2pdf__page-break"/>-->

                        <el-col :span="24" v-if="showSectionSwitch">
                          <el-checkbox  v-model="eachFormObj.showSection">Check if applicable</el-checkbox>
                        </el-col>
                        <el-divider :key="`divider-${eachFormIndex}`" content-position="center">{{ eachFormObj.title }}</el-divider>
                        <el-row :key="`row-${eachFormIndex}`" v-show="getSectionView(eachFormIndex)">
                          <div class="wrapper--forms">
<!--                            <el-col :xs="24" :sm="24"-->
                            <el-col
                                    v-for="(field, index) in eachFormObj.fields"
                                    :key="index"
                                    :span="field.span"
                                    v-bind="field"
                                    class="form__group, position-relative pdf-item"
                                    :class="{'is---active':componentFieldId === field.componentId,}"
                                    >

                              <div @click="editElementProperties(field)">
                                <component :class="{'is---active':componentFieldId === field.componentId,}"
                                           :is="field.fieldType"
                                           :currentField="field"
                                           class="form__field"
                                ></component>

                              </div>

                              <div class="form__actiongroup text-right"
                                   v-if="showStyleDiv == false && field.showComments"
                                   :style="hideOnPrint == true ? 'display:none' : 'display:block'">
                                <el-button-group
                                    class="form__actionlist hide_button"
                                    :class="{show_party:componentFieldId === field.componentId,}">
                                  <!--                                comment Icon    icon="el-icon-plus"-->
                                  <el-button size="mini" icon="el-icon-plus"
                                             @click="(event)=>cloneElementField(index,field,eachFormObj.fields, event)"
                                             v-show="!field.isUnique"
                                  ></el-button>
                                  <div class="comment-section" :id="'comment-container-'+field.componentId"
                                       ref="commentRefClick">
                                    <div class="message-input d-flex p-2 align-items-center">
                                      <input
                                          type="text"
                                          :v-bind-value="textComment[field.componentId]"
                                          class="form-control"
                                          placeholder="Type Comment"
                                          v-model="textComment[field.componentId]"
                                          v-on:keydown.enter.prevent="enter(textComment, field.componentId)"
                                      />
                                      <div class="message-input-append">
                                        <a
                                            href="#"
                                            class="btn btn-send p-2"
                                            @click.prevent="enter(textComment, field.componentId)"
                                        >
                                          <app-icon name="send" class="size-25"/>
                                        </a>

                                      </div>
                                    </div>
                                    <div class="card-body pb-0">
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <div class="my-3 aqeel-class"
                                               v-for="(comm, commentIndex) in commentObject[field.componentId]"
                                               :key="commentIndex">
                                            <div class="d-flex" style="justify-content: space-between">
                                                    <span class="meta">
                                                      <app-media-object :media-title="comm.user"/>
                                                      <p>{{ comm.created_at | formatDate }}</p>
                                                    </span>

                                              <el-dropdown trigger="click">

                                                <el-button type="primary" class="btn btn-sm"
                                                           style="background: white;color: #4466f2;border: none;">
                                                  <app-icon name="more-vertical"
                                                            style="width: 10px !important;height: 10px !important;"/>
                                                </el-button>
                                                <el-dropdown-menu slot="dropdown">

                                                      </el-dropdown-menu>
                                                    </el-dropdown>
                                                  </div>
                                                  <p style="margin: 6px 0;border-bottom: 1px solid rgb(137 137 137 / 53%);">{{ comm.text }}</p>
                                                </div>
                                              </div>
                                            </div>

                                          </div>


                                    </div>
                                  </el-button-group>
                                </div>

                              </el-col>

                          </div>
                          </el-row>

                      </template>
                    </el-form>
                  </el-main>
                </el-container>
              <div class="form-footer" ref="formFooter">
                <div class="row btn-border m-3 align-items-center" />
                <div style="display: flex; justify-content:space-between" class="ml-4 mr-4">
                  <p>
                    <small>Form ID: {{companyInfo.company_name && companyInfo.company_name.match(/\b(\w)/g).join('')+'C'+formInfo.id}}</small>
                  </p>
                  <p>
                    <small>Version: {{formInfo.version}}</small>
                  </p>
                </div>
              </div>
              </div>
              </div>
            <div class="styling-block" v-if="showStyleDiv == true">
              <!-- For Form Styling Div -->

              <div class="col-12 collapse-title-size">
                <el-collapse v-model="activeName" accordion class="mt-3 border-top-none">
                  <!-- Header Setting -->
                  <el-collapse-item title="Header Setting" name="1">
                    <div class="row mb-2 p-2">
                      <div class="col-12 mb-2">
                        <h5>Select header content</h5>
                      </div>

                      <div class="col-6 mb-2">
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('logo')"
                              v-model="companyInfoCheck.checked_logo"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_name')"
                              v-model="companyInfoCheck.checked_company_name"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_number')"
                              v-model="companyInfoCheck.checked_company_number"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('category_name')"
                              v-model="companyInfoCheck.checked_category_name"
                          />
                        </div>
                      </div>
                      <div class="col-6 mb-2">
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_email')"
                              v-model="companyInfoCheck.checked_company_email"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_phone')"
                              v-model="companyInfoCheck.checked_company_phone"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('address')"
                              v-model="companyInfoCheck.checked_address"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('description')"
                              v-model="companyInfoCheck.checked_description"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2 p-2">
                      <div class="col-12 mb-2">
                        <div class="row p-2">
                          <div class="col-6 p-2">
                            <label for="inputs_form_header_color" class="mb-0">{{ $t("Header background color") }}</label>
                            <input id="inputs_form_header_color" class="form-control" type="color" v-model="form_header_color"/>
                          </div>

                          <div class="col-6 p-2">
                            <label for="form_header_text_color" class="mb-0">{{ $t("Header text color") }}</label>
                            <input id="form_header_text_color" class="form-control" type="color" v-model="form_header_text_color"/>
                          </div>
                        </div>


                      </div>
                    </div>
                  </el-collapse-item>
                  <!-- Header Setting -->

                  <!-- Form Styling -->
                  <el-collapse-item title="Form Designer" name="2">
                    <div class="row mb-2 p-2">
                      <div class="col-12">
                        <h5>Select your Theme</h5>
                      </div>
                    </div>
                    <div class="row mb-3 p-2">
                      <div class="col-3">
                        <div class="box-01">
                          <p class="box-text-color" @click.prevent="changeColor(1)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-02">
                          <p class="box-text-color" @click.prevent="changeColor(2)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-03">
                          <p class="box-text-color" @click.prevent="changeColor(3)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-04">
                          <p class="box-text-color" @click.prevent="changeColor(4)">A</p>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-5 p-2">
                      <div class="col-6">
                        <label for="inputs_form_color" class="mb-0">{{ $t("form_color") }}</label>
                        <input id="inputs_form_color" class="form-control" type="color" v-model="form_color"/>
                      </div>
                      <!-- <div class="col-6">
                        <label for="inputs_form_border_color" class="mb-0">{{ $t("form_border_color") }}</label>
                        <input
                            id="inputs_form__border_color"
                            class="form-control"
                            type="color"
                            v-model="form_border_color"
                        />
                      </div> -->
                    </div>
                    <div class="row mb-5 p-2">
                      <div class="col-6 mt-2">
                        <label for="inputs_font_color" class="mb-0">{{ $t("font_color") }}</label>
                        <input id="inputs_font_color" class="form-control" type="color" v-model="font_color"/>
                      </div>
                      <!-- <div class="col-6 mt-5">
                        <label for="inputs_input_back_color" class="mb-0">
                          {{ $t("input_back_color") }}
                        </label>
                        <input id="inputs_input_back_color"
                          class="form-control"
                          type="color"
                          v-model="inputs.input_back_color">
                      </div>-->
                    </div>
                  </el-collapse-item>
                  <!-- Form Styling -->

<!--                  Form background settings-->
                  <el-collapse-item title="Form Background Settings" name="3">
                    <div class="row mb-5 p-2">
                      <div class="col-6">
                        <label for="inputs_form_background_color" class="mb-0">{{ $t("form_background_color") }}</label>
                        <input id="inputs_form_background_color" class="form-control" type="color" v-model="form_background_color"/>
                      </div>
                      <!-- <div class="col-6">
                        <label for="inputs_form_border_color" class="mb-0">{{ $t("form_border_color") }}</label>
                        <input
                            id="inputs_form__border_color"
                            class="form-control"
                            type="color"
                            v-model="form_border_color"
                        />
                      </div> -->
                    </div>

                  </el-collapse-item>

                  <!--                  Form background settings-->

                </el-collapse>
                <div class="row">
                  <div class="col-12 mt-5" style="display:flex; justify-content:space-between">
                    <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click.prevent="previous"
                    >{{ $t("Previous") }}
                    </button>
                    <!-- </div>
                    <div class="col-6 mt-5">-->
                    <button
                        type="button"
                        class="btn btn-success"
                        @click.prevent="saveStyling"
                    >{{ $t("Save Styling") }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- For Form Styling Div -->
            </div>
            </div>

          <div class="my-3 mx-auto text-center form-footer-buttons" v-if="isLock === 'no' && !isUseTemplate && !showStyleDiv && (!isBuilder || response === 'view')">
            <div v-if="is_shareResponse === false">
              <div v-if="showActions">
                <div class="d-flex flex-wrap justify-content-center">
                  <!-- Draft Button -->
                  <app-load-more
                      v-if="formStatus !== 'submitted' || formStatus !== 'pending'"
                      :preloader="actionPreloader"
                      :label="$t('save_as_draft')"
                      type="submit"
                      class-name="btn-dark m-2"
                      @submit="saveForm('draft')"
                  />

                  <!-- Save & Submit Button -->
                  <app-load-more
                      v-if="invoice_Status === 'succeeded' && formStatus !== 'pending'"
                      :preloader="actionPreloader"
                      :label="$t('save_&_submit')"
                      type="submit"
                      class-name="btn-success m-2"
                      @submit="saveForm('submitted')"
                  />

                  <!-- Update Strategy -->
                  <app-input
                      class="m-2"
                      type="radio-buttons"
                      :list="updateStrategyList"
                      v-model="isUpdateStrategy"
                  />
                </div>
              </div>

              <div class="d-flex flex-wrap justify-content-center" v-if="showFormActions('ownerAccess', 'status_response') || showFormActions('auditorAccess', 'status_response')">
                <!-- Reject Button -->
                <app-load-more
                    v-if="formStatus !== 'pending'"
                    :preloader="actionPreloader"
                    :label="$t('reject')"
                    type="submit"
                    class-name="btn-danger m-2"
                    @submit="taskAudit('rejected')"
                />

                <!-- Approve Button -->
                <app-load-more
                    v-if="response == null && formStatus !== 'pending'"
                    :preloader="actionPreloader"
                    :label="$t('approve')"
                    type="submit"
                    class-name="btn-success m-2"
                    @submit="taskAudit('approved')"
                />
              </div>

              <div class="d-flex flex-wrap justify-content-center" v-if="!showActions && response != 'save-response-view' && isMyForm">
                <!-- Save Response Button -->
                <app-load-more
                    :preloader="actionPreloader"
                    :label="$t('save_response')"
                    type="submit"
                    class-name="btn-success m-2"
                    @submit="saveResponse('submitted')"
                />

                <!-- Share Response -->
                <ShareResponse v-if="view_type != 'view'" class="m-2" />
              </div>

              <div class="d-flex flex-wrap justify-content-center">
                <!-- Print Button -->
                <app-load-more
                    :preloader="actionPreloader"
                    :label="$t('print')"
                    type="submit"
                    class-name="btn-primary m-2"
                    @submit="generateReport"
                />

                <!-- Back Button -->
                <el-button
                    v-if="showBackButton"
                    type="primary"
                    @click.prevent="backToList"
                    class="m-2"
                >
                  Back
                </el-button>
              </div>
            </div>
          </div>

          <!-- Locked State -->
          <div class="text-center" v-if="isLock === 'yes'">
            <app-load-more
                :preloader="actionPreloader"
                :label="$t('lock_response')"
                type="submit"
                class-name="btn-warning m-2"
                @submit="saveForm('draft')"
            />
          </div>

        </div>

      </div>
    </div>
    <!--Delete Modal-->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="task-delete"
      @confirmed="confirmed"
      @cancelled="canceled"
    />

  </div>

</template>

<script>
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {FormBuilder} from "../../CustomFormBuilder/form_elements/formbuilder";
import {axiosGet, axiosPost} from "@/app/Helpers/AxiosHelper";
import VueHtml2pdf from 'vue-html2pdf'
import {BODY_STYLE_UPDATE, SHARE_RESPONSE_VIEW, TASK_ASSIGN_FORM_SHOW} from "@/app/Config/ApiUrl";
import ShareResponse from "@Views/SuperAdmin/Task/Form/ShareResponse";
import {
  addPageBreaks,
  beforeDownload,
  checkAndAddPageBreak,
  cloneElementField,
  deleteComment,
  editElementProperties,
  enter,
  focusInput,
  generatePdf,
  generateReport,
  getAllDocumentStyles,
  getInputsComments,
  getQueryParam,
  getSectionView,
  getStyles,
  invoiceStatus,
  onPdfComplete,
  reloadFun,
  saveForm,
  setDefaultColor,
  setFormColor,
  showFormActions,
  startPagination,
  taskAudit,
  waitForStylesheets
} from '@Views/CustomFormBuilder/utilities/formPreview'

export default {
  name: "FormPreview",

  components: {
    ...FormBuilder.$options.components,
    VueHtml2pdf,
    ShareResponse
  },
  mixins: [ModalMixin, FormMixin],
  props: {
    new_tab: String,
    lock: String,
    id: {type:[String,Number], required: true},
    // taskId: {type:[String,Number], required: true},
    form_id:  {type:Number, required: true},
    form_revision_id: {type:Number, required: true},
    type: {type:String },
    showStyleDiv: Boolean,
    backList: Function,
    // userId: {type:[Number, String]},
    response: String,
    back: Function,
    hidePrevious: String,
    formType: String,
    data:{},
    isMyForm: {type:Boolean, default:true},
    isUseTemplate: {type: Boolean, default: false},
    isBuilder: {type: Boolean, default: false},
  },
  data() {
    return {
      showSectionSwitch: true,
      updateStrategyList: [
        {
          id: 'update',
          value: 'Update Existing'
        },{
          id: 'create',
          value: 'Create New'
        },],
      isUpdateStrategy: 'create',
      is_shareResponse: this.$props.data?.shareResponse ?? false,
      isNewTab: this.new_tab ?? 'no',
      isLock: this.lock ?? 'no',
      isActive: false,
      responseStatus: '',
      // flag: null,
      // formDesign: this.$store.state.formdesigner.formstyling,
      savedFormBodyStyle:[],
      activeName: 1,
      companyInfoCheck: {
          checked_company_name: false,
          checked_logo: false,
          checked_company_number: false,
          checked_company_email: false,
          checked_company_phone: false,
          checked_address: false,
          checked_description: false,
          checked_category_name: false,
        },
      formStatus: '',
      hideOnPrint:false,
      formInfo: {},
      on_select: false,
      form_color: "",
      form_background_color: "",
      form_header_color: "",
      form_header_text_color: "",
      font_color: "",
      select_color: [{
        form_header_color: this.form_header_color,
        form_header_text_color: this.form_header_text_color,
        form_color: this.form_color,
        font_color: this.font_color,
        form_background_color: this.form_background_color,
      }],
      // form_border_color: "",
      root: null,
      // accentColor: '#000',
      view_type: "",
      companyInfo: {},
      user_id: "",
      invoice_Status: "succeeded",
      remove_id: "",
      deleteConfirmationModalActive: false,
      uploadFilePathfinal: {},
      fieldId: [],
      textCommentId: 0,
      commentRequest: {},
      textComment: {},
      created_by: 0,
      task_id: "",
      form_body_id: 0,
      forms: this.$store.state.formBuilder.forms,
      commentObject: {},
      commentText: "",
      componentFieldId: 0,
      themingVars: this.$store.state.formBuilder.themingVars,
      preloader: false,
      actionPreloader: false,
      showComments: false,
      showActions: true,
      inputs: {
        yes: "no"
      },
      // status:'',
      modalId: "form-view-Modal",
      modalTitle: this.$t("add"),
      color_data: [
        {
          theme_no: 1,
          form_color: "#F0FCFF",
          // form_border_color: "#83D0E4",
          font_color: "#264B67"
        },
        {
          theme_no: 2,
          form_color: "#FFDF79",
          // form_border_color: "#FB6F41",
          font_color: "#6A1B00"
        },
        {
          theme_no: 3,
          form_color: "#EFE8D4",
          // form_border_color: "#5A4B44",
          font_color: "#321F16"
        },
        {
          theme_no: 4,
          form_color: "#E4EFFF",
          // form_border_color: "#2462B9",
          font_color: "#12458D"
        }
      ]
    };
  },
  methods: {
    getSectionView,
    showFormActions,
    checkAndAddPageBreak,
    backToList() {
      this.back();
    },
    changeColor(num) {
      
      this.on_select = true;
      this.select_color = this.color_data.filter(data => {
        return data.theme_no === num;
      });
      this.root.style.setProperty(
        "--form-color",
        this.select_color[0].form_color
      );
      this.root.style.setProperty(
        "--form-header-color",
        this.select_color[0].form_header_color
      );
      this.root.style.setProperty(
        "--form-header-text-color",
        this.select_color[0].form_header_text_color
      );
      // this.root.style.setProperty(
      //   "--form-border-color",
      //   this.select_color[0].form_border_color
      // );
      this.root.style.setProperty(
        "--font-color",
        this.select_color[0].font_color
      );
      //  
    },

    startPagination,
     onPdfComplete,
    waitForStylesheets,
    generateReport,
    generateReport2(){
      setTimeout(() => {
         this.generateReport()
      }, 5000)
    },

    getStyles,
    getAllDocumentStyles,
    addPageBreaks,
    generatePdf,
    beforeDownload,

    previous() {
      if (this.formType && this.formType === 'import_body_styling') {
            this.$store.commit('deleteSharedData',"showFormActions");
          this.back();
      }
      else {
        this.$emit(" ", 1);
      }
    },
    saveStyling() {
      
        // console.log(this.companyInfoCheck);
      // if(this.on_select == true){
      let bodyStyling = JSON.stringify(this.select_color);
      let headerContent = JSON.stringify(this.companyInfoCheck)
      if (this.formType && this.formType === 'import_body_styling') {
          this.$emit('styling',bodyStyling, headerContent);
      }
      else {
        axiosPost(BODY_STYLE_UPDATE, {
          bodyStyling: bodyStyling,
          headerContent: headerContent,
          form_body_id: this.id
        }).then(res => {
            this.$toastr.s(res.data.message);
            this.backList();
            this.select_color = [];
          }).catch(res => {
          console.error(res)
          });
        // }else{
        //     this.$toastr.s("Form save without styling");
        //     this.backList();
        // }

      }
    },
    removeFileAction(fileid) {
      this.remove_id = fileid;
      this.deleteConfirmationModalActive = true;
      // this.$store.state.uploadFilePath.dataUploadFilePath.splice(fileid , 1);
    },
    canceled() {
      this.remove_id = "";
      this.deleteConfirmationModalActive = false;
    },
    confirmed() {
      this.$store.state.uploadFilePath.dataUploadFilePath.splice(
        this.remove_id,
        1
      );

      this.hideDeleteModal();
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#task-delete").modal("hide");
      this.canceled();
    },
     getData() {// let form_id = this.getQueryParam();
      /**
       * * Pass the value to server, so that we can get required form response,
       * */
      if(this.$props.response == 'view') {
        this.showActions = false;
      }
      let url;
      if(this.is_shareResponse === true) {
        url = `${SHARE_RESPONSE_VIEW}/${this.$props.data.link}`;
      }
      else {
        if (typeof this.taskId == "undefined") {
          if(this.response === "save_response" || this.response == 'save-response-view') {
            this.showActions = false;
            url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?form_id=${this.$props.form_id}&form_revision_id=${this.$props.form_revision_id}&type=${this.$props.response}&user_id=${this.$props.data?.user_id??this.$props.userId}&batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;
          }
          else {
            url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?form_id=${this.$props.form_id}&task_id=${this.$props.taskId??''}&form_revision_id=${this.$props.form_revision_id??''}&type=${this.$props.response}&user_id=${this.$store.state.sharedData?.sharedData?.guestFormData?.user_id}&guest=${this.$store.state.sharedData.sharedData?.guestFormData?.guest} &batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;

            // url = `${TASK_ASSIGN_FORM_SHOW}/${this.id}?type=view`;
          }
        } else if(typeof this.userId != "undefined") {
          url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?task_id=${this.$props.taskId??this.$attrs.taskId??this.$props.data?.task_id}&form_id=${this.$props.form_id}&form_revision_id=${this.form_revision_id}&user_id=${this.$props.data?.user_id??this.$store.state.sharedData.sharedData?.guestFormData?.user_id}&guest=${this.$store.state.sharedData.sharedData?.guestFormData?.guest} &batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;
        }
        else{
          url = `${TASK_ASSIGN_FORM_SHOW}/${this.id}?task_id=${this.taskId}&form_id=${this.form_id}&form_revision_id=${this.form_revision_id}`;
        }
      }
      this.$store.commit('updateSharedData', {index: "formPreviewUrl", newValue: url})
      axiosGet(url)
        .then(res => {

          if (res.data.length !== 0) {
            // this.forms = res.data.body;
            this.forms = res.data.body.map(form => ({

                ...form,
                showSection: form.hasOwnProperty('showSection') ? form.showSection : true
              }));

            // Ensure library forms don't ship with preselected radios
            if (this.isBuilder === true && (this.response === 'view' || this.response === '' || this.response == null)) {
              try {
                this.forms = this.forms.map(f => {
                  f.fields = (f.fields || []).map(field => {
                    if (field.fieldType === 'RadioButton') {
                      // Only clear if there's no persisted response object
                      if (!res.data.response_status) {
                        field.componentValue = '';
                      }
                    }
                    return field;
                  });
                  return f;
                });
              } catch (e) {}
            }

            this.form_body_id = res.data.id;
            // this.form_id = res.data.form_id;
            this.user_id = res.data.user_id;
            this.companyInfo = res.data.companyInfo;
            this.view_type = res.data.view_type ?? '';
            this.formInfo = res.data.form_revision;
            this.created_by = res.data.form_revision.created_by;
            this.companyInfoCheck = JSON.parse(res.data.header_content);
            this.formStatus = res.data.status;
            this.responseStatus = res.data.response_status;

            let data = JSON.parse(res.data.bodyStyle);
            this.savedFormBodyStyle = data
            
            // this.changeColor(data[0].theme_no);
            if (data && data.length > 0) {
              this.root.style.setProperty("--form-color", data[0].form_color);
              this.root.style.setProperty("--font-color", data[0].font_color);
              this.root.style.setProperty("--form-header-color", data[0].form_header_color??'#fff');
              this.root.style.setProperty("--form-header-text-color", data[0].form_header_text_color??'#000000');

            } else {
              this.root.style.setProperty("--form-color", "#fff");
              // this.root.style.setProperty("--form-border-color", "#898989");
              this.root.style.setProperty("--font-color", "#000");
            }

            // if (res.data.status == 2) {
            //   this.status = res.data.status;
            // }
            
            this.getInputsComments();
          }
        })
        .catch(res => {
          this.$toastr.e(res.response.data.message);
          this.$toastr.e('Closing in 3 sec...');
          setTimeout(function() {
            window.close();
          }, 3000);
        });
    },
    saveForm,
    getQueryParam,
    // deleteElement(index, form) {
    //   FormBuilder.deleteElement(index, form);
    // },
    cloneElementField,
    editElementProperties,
    focusInput,
    enter,
    editComment(commentIndex, i, comm) {
      this.$set(this.textComment, i, comm.text);
      this.textCommentId = comm.text_id;


      if (this.textComment !== null) {
        this.reloadfun(i);
        this.focusInput(i);
      }
    },
    deleteComment,
    reloadFun,
    setDefaultColor,
    setFormColor,
    getInputsComments,
    invoiceStatus,
    taskAudit,
    saveResponse(status) {
     if (this.$props.response == 'view') {
      let url = '/form-response?formId=' + encodeURIComponent(this.formInfo.form_id);
        window.open(url, '_blank');
     }
     else {
      this.saveForm(status)
     }
    }
  },
  created() {
    // this.$store.state.inputMode.type = !this.$store.state.inputMode.type;
  },
  watch: {
    form_header_color(){
      this.root.style.setProperty("--form-header-color", this.form_header_color);
      this.select_color[0].form_header_color = this.form_header_color;
      // this.select_color[0] = { form_header_color: this.form_header_color };
      // this.select_color.unshift({ form_header_color: this.form_header_color });

    },
    form_header_text_color(){
      this.root.style.setProperty("--form-header-text-color", this.form_header_text_color);
      // this.select_color[0].form_header_text_color = this.form_header_text_color;
      // this.select_color[0] = { form_header_text_color: this.form_header_text_color };
      this.select_color[0].form_header_text_color = this.form_header_text_color;

    },
    form_color() {
      // this.$store.state.formdesigner.formstyling = {
      //   form_color: this.form_color,
      //   form_border_color: this.form_border_color,
      //   font_color: this.font_color,

      // };
      // const form_colortest = this.form_color;
      this.root.style.setProperty("--form-color", this.form_color);
      this.select_color[0].form_color = this.form_color;



      // this.select_color[0].form_color = this.form_color;
    },
    form_border_color() {
      // this.$store.state.formdesigner.formstyling.form_border_color = this.form_border_color;
      this.root.style.setProperty(
        "--form-border-color",
        this.form_border_color
      );
      this.select_color[0].form_border_color = this.form_border_color;
    },
    font_color() {
      // this.$store.state.formdesigner.formstyling.font_color = this.font_color;
      this.root.style.setProperty("--font-color", this.font_color);
      this.select_color[0].font_color = this.font_color;
    },
  },

  computed: {
    showBackButton(){
      return this.$store.state.sharedData.sharedData?.showBackButton??false;
    },
    
    taskId(){
       return this.data?.task_id?? this.$store.state.sharedData.sharedData.taskId;
    },
    userId(){
      return this.data?.user_id
        ?? this.$props.userId
        ?? this.$store.state.sharedData.sharedData?.guestFormData?.id;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    filePath() {
      return this.$store.state.uploadFilePath.dataUploadFilePath;
      //  this.$store.dispatch("setValueToPass", documents);
    },
    cssProps() {
      // Return an object that will generate css properties key
      // to match with the themingVars
      //
      // Example output: { '--theme-primary-color': this.themingVars.primaryColor }
      var result = {},
        themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = "--theme-" + _.kebabCase(v),
            suffix = "";

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, "size")) suffix = "px";
          else if (_.includes(newV, "margin")) suffix = "px";
          else if (_.includes(newV, "radius")) suffix = "px";

          result[newV] = themingVars[v] + suffix;
        }
      }
      return result;
    },

  },
  mounted() {
    this.getData();
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    this.$store.state.inputMode.type = false;
    // this.invoiceStatus();
    this.root = document.documentElement;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkSectionHeight);
  },

};
</script>
<style scoped>
.el-form-item .el-form-item {
  margin-bottom: 0 !important;
}
@media print {
  .stacked-divs{
    max-width: 100% !important;
    width: 100% !important;
  }
  /* Adjust flex properties */
  .my-3 {
    display: block; /* Ensure containers are treated as block elements */
  }

  .flex-item {
    display: block; /* Ensure items are treated as block elements */
    width: 100%; /* Ensure items take full width if needed */
    page-break-inside: avoid; /* Prevent breaking inside items if necessary */
  }
  .flex-item .float-right{
    margin-left: auto;
  }


  /* Additional print-specific adjustments */
  /* Hide any elements that are not necessary in print */
  .no-print {
    display: none !important;
  }
  body {
    margin: 0;
  }

  .no-print {
    display: none;
  }

  /* Avoid page breaks inside these elements */
  .avoid-break {
    page-break-inside: avoid;
  }

  /* Force page breaks before or after elements as needed */
  .page-break-before {
    page-break-before: always;
  }

  .page-break-after {
    page-break-after: always;
  }

  /* Ensure the content fits within the printable area */
  .print-container {
    overflow: visible;
  }
  .print-placeholder::placeholder {
    color: white; /* Color for printing */
  }
}
</style>
